import React from 'react';
import SendRequestToRemoveAccountConnectorApollo from '../Connector/Apollo/RemoveAccount/SendRequestToRemoveAccount/SendRequestToRemoveAccountConnectorApollo';
import ActiveSubscriptionConnectorApollo from '../Connector/Apollo/RemoveAccount/ActiveSubscription/ActiveSubscriptionConnectorApollo';
import RemoveAccountRequestContainer from './RemoveAccountRequestContainer';

const RemoveAccountRequestPage = () => {
    return (
        <ActiveSubscriptionConnectorApollo>
            {ActiveSubscriptionData => (
                <SendRequestToRemoveAccountConnectorApollo>
                    {SendRequestToRemoveAccountData => {
                        return (
                            <RemoveAccountRequestContainer
                                loading={
                                    SendRequestToRemoveAccountData.loading ||
                                    ActiveSubscriptionData.loading
                                }
                                sendRequestToRemoveAccount={() =>
                                    SendRequestToRemoveAccountData.sendRequestToRemoveAccount()
                                }
                                activeSubscription={
                                    ActiveSubscriptionData.activeSubscriptions
                                }
                                userEmail={ActiveSubscriptionData.email}
                            />
                        );
                    }}
                </SendRequestToRemoveAccountConnectorApollo>
            )}
        </ActiveSubscriptionConnectorApollo>
    );
};

export default RemoveAccountRequestPage;
